module.exports = __webpack_public_path__ + "img/South Sudan.481a9a15.svg";